import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const GaugeGlyph = /*#__PURE__*/createElement("g", {
  id: "gauge",
  style: {
    transform: 'translate(4px, 0) scale(2.8, 2.8)'
  },
  fill: "none"
}, /*#__PURE__*/createElement("circle", {
  cx: "10",
  cy: "10",
  r: "9.5"
}), /*#__PURE__*/createElement("path", {
  d: "M15.0001 6.06296C15.8541 7.14611 16.3637 8.51348 16.3637 9.99987C16.3637 11.9567 15.4805 13.7072 14.091 14.8745M5.9092 14.8745C4.51968 13.7072 3.63647 11.9567 3.63647 9.99987C3.63647 6.48533 6.48557 3.63623 10.0001 3.63623C10.7609 3.63623 11.4905 3.76973 12.1668 4.01458",
  strokeLinecap: "round"
}), /*#__PURE__*/createElement("line", {
  x1: "14.5996",
  y1: "4.34125",
  x2: "9.79589",
  y2: "9.94563",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const Gauge = createSvg({
  name: 'gauge',
  path: GaugeGlyph
});

export default Gauge;
export { GaugeGlyph };
